import { api } from './Api';

class KonkursyService {
  getBuilder() {
    return api.get('konkursy/getBuilder.php');
  }

  saveBuilder(structure) {
    return api.post('konkursy/saveBuilder.php', {
      StructureJson: JSON.stringify(structure)
    }).then((response) => {
      if (response?.csrf) {
        api.setCsrf(response.csrf);
      }
      return response;
    });
  }

  deleteTemplate(id) {
    return api.post('konkursy/deleteTemplate.php', { Id: id }).then((response) => {
      if (response?.csrf) {
        api.setCsrf(response.csrf);
      }
      return response;
    });
  }

  saveLibraryItem(type, item) {
    return api.post('konkursy/saveLibraryItem.php', {
      Type: type,
      ItemJson: JSON.stringify(item)
    }).then((response) => {
      if (response?.csrf) {
        api.setCsrf(response.csrf);
      }
      return response;
    });
  }

  deleteLibraryItem(type, id) {
    return api.post('konkursy/deleteLibraryItem.php', {
      Type: type,
      Id: id
    }).then((response) => {
      if (response?.csrf) {
        api.setCsrf(response.csrf);
      }
      return response;
    });
  }

  saveAssignments(assignments) {
    return api.post('konkursy/saveAssignments.php', {
      AssignmentsJson: JSON.stringify(assignments)
    }).then((response) => {
      if (response?.csrf) {
        api.setCsrf(response.csrf);
      }
      return response;
    });
  }
}

export const konkursyService = new KonkursyService();
